import React from "react";
import styles from "./WizardHeader.module.scss";
import SVG from "react-inlinesvg";
import { CloseIcon } from "@netapp/bxp-style/react-icons/Action";
import { StyledLink, Heading, Button } from "../..";

const WizardHeader = ({ logo, Icon, label, children, onClose, closeLink, Widgets }) => {
    return <header className={styles.base}>
        <div className={styles.label}>
            {logo && <SVG src={logo}/>}
            {Icon && <Icon/>}
            <Heading level={20} color="text-title" ellipsis>{label}</Heading>
        </div>
        {children && <div className={styles.contents}>
            {children}
        </div>}
        {!children && <div/>}
        <div className={styles['widgets-container']}>
            {Widgets && <Widgets/>}
            {onClose && <Button variant="icon" color="secondary" onClick={onClose} className={styles.close}><CloseIcon/></Button>}
            {closeLink && <StyledLink type="icon" color="secondary" className={styles.close} to={closeLink}><CloseIcon/></StyledLink>}
        </div>
    </header>
}

export default WizardHeader;
